import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'small-round-btn',
  templateUrl: './small-round-btn.component.html',
  styleUrls: ['./small-round-btn.component.scss'],
})
export class SmallRoundBtnComponent implements OnInit {
  @Input()
  public icon: string = null;

  @Input()
  public click: Function = null;

  @Input()
  public tiny: boolean = false;

  constructor() {}

  ngOnInit() {}

  public internClick() {
    if (this.click) this.click();
  }
}
